import React from 'react';

import TopBanners from '../TopBanners/TopBanners';
import BigBanner from '../BigBanner/BigBanner';
import AdviceBox from '../AdviceBox/AdviceBox';

const ModuleSlider = ({
  home,
  tags,
  primaryColor,
  uiVariantBannerHeader,
  uiVariantSlider,
  uiVariantSliderTagsSide,
}) => {
  return (
    <div className="container">
      <TopBanners
        home={home}
        uiVariantBannerHeader={uiVariantBannerHeader}
        uiVariantSliderTagsSide={uiVariantSliderTagsSide}
      />
      <div
        className="row"
        style={{
          flexDirection:
            uiVariantSliderTagsSide === 'sx' ? 'row-reverse' : 'row',
        }}
      >
        <div className="col-lg-9">
          <BigBanner
            home={home}
            primaryColor={primaryColor}
            rounded={uiVariantSlider === '1'}
            dotsOnRight={uiVariantSlider === '1'}
            uiVariantSlider={uiVariantSlider}
          />
        </div>
        <div className="col-lg-3">
          <AdviceBox
            tags={tags}
            adviceTitle={home.adviceTitle}
            primaryColor={primaryColor}
            uiVariantSlider={uiVariantSlider}
          />
        </div>
      </div>
    </div>
  );
};

export default ModuleSlider;
